import {getField, updateField} from 'vuex-map-fields';
import first from 'lodash/first';
import isUndefined from 'lodash/isUndefined';
import filter from 'lodash/filter';
import {getConstructionMaterial, getConstructionOptions} from './api/construction';
import {materialCalculation} from './helpers/calculator';

export const calculationModule = {
    namespaced: true,
    state:      {
        userInput:         {
            meters: 20,
            cut:    5,
        },
        projects:          {
            selectedSlug: null,
            data:         [],
        },
        construction:      {
            selectedId: null,
            data:       null,
            material:   [],
        },
        contacts:          {
            selectedId: null,
        },
        demandInformation: {
            name:          null,
            surname:       null,
            email:         null,
            phone:         null,
            address:       null,
            city:          null,
            zip:           null,
            note:          null,
            pickUpAtStore: false,
            withWork:      false,
            mktApproval:   false,
        },
        demandWithWork:    false,
        bim:               {
            id: null,
        }
    },
    getters:    {
        getField,

        userInputCut: (state) => state.userInput.cut,

        // USER
        userInput:   (state) => state.userInput,
        finalMeters: (state) => {
            const { meters, cut } = state.userInput;
            const metersNumber = parseInt(meters);
            const cutNumber = parseInt(cut);

            return metersNumber + ((metersNumber / 100) * cutNumber);
        },

        // PROJECT
        projects:            (state) => state.projects.data,
        projectBySlug:       (state, getters) => (projectSlug) => {
            const projects = filter(getters.projects, ({ slug }) => projectSlug === slug);
            const project = first(projects);
            return isUndefined(project) ? null : project;
        },
        selectedProject:     (state, getters) => getters.projectBySlug(getters.selectedProjectSlug),
        selectedProjectSlug: (state) => state.projects.selectedSlug,

        // CONSTRUCTION
        construction:                   (state) => state.construction.data,
        constructionDocuments:          (state, getters) => getters.construction ? getters.construction.documents : [],
        constructionMaterial:           (state) => state.construction.material,
        calculatedConstructionMaterial: (state, getters) => materialCalculation(getters.construction, getters.finalMeters),
        selectedConstructionId:         (state) => state.construction.selectedId,

        // REQUEST
        requestParameters: (state, getters) => (type) => {
            const { meters, cut } = getters.userInput;
            return {
                input:             { meters, waste: cut },
                products:          getters.calculatedConstructionMaterial,
                construction:      getters.selectedProject,
                constructionId:    getters.selectedConstructionId,
                bimId:             getters.bimId,
                contactId:         getters.contactId,
                demandInformation: getters.demandInformation,
                demandWithWork:    getters.demandWithWork,
                type
            };
        },

        // CONTACTS
        contactId: (state) => state.contacts.selectedId,

        // BIM
        bimId: (state) => state.bim.id,

        // DEMAND
        demandInformation: state => state.demandInformation,
        demandWithWork:    (state) => state.demandWithWork,
    },
    actions:    {
        // FETCH
        fetchProjects:     ({ commit }) => getConstructionOptions().then((data) => commit('setProjectsData', data)),
        fetchConstruction: ({ commit, getters }) => {
            return getConstructionMaterial(getters.selectedConstructionId)
            .then((data) => {
                const { productGroups } = data;
                commit('setConstructionData', data);
                commit('setConstructionMaterialData', productGroups);
            });
        },

        // PROJECT
        setProjectSlug: ({ commit }, projectSlug) => commit('setProjectSlug', projectSlug),

        // CONSTRUCTION
        setConstructionId:           ({ commit }, constructionId) => commit('setConstructionId', constructionId),
        setConstructionMaterialData: ({ commit }, data) => commit('setConstructionMaterialData', data),

        // CONTACTS
        setContactId: ({ commit }, contactId) => commit('setContactId', contactId),

        // BIM
        setBimId: ({ commit }, bimId) => commit('setBimId', bimId),

        // DEMAND WITH WORK
        setDemandWithWork: ({ commit }, demandWithWork) => commit('setDemandWithWork', demandWithWork),

        setUserInputCut: ({ commit }, value) => commit('setUserInputCut', value),
    },
    mutations:  {
        updateField,

        // PROJECT
        setProjectsData: (state, data) => state.projects.data = data,
        setProjectSlug:  (state, projectSlug) => state.projects.selectedSlug = projectSlug,

        // CONSTRUCTION
        setConstructionId:           (state, constructionId) => state.construction.selectedId = constructionId,
        setConstructionData:         (state, data) => state.construction.data = data,
        setConstructionMaterialData: (state, data) => state.construction.material = data,

        // CONTACTS
        setContactId: (state, contactId) => state.contacts.selectedId = contactId,

        // BIM
        setBimId: (state, bimId) => state.bim.id = isUndefined(bimId) ? null : bimId,

        // DEMAND WITH WORK
        setDemandWithWork: (state, demandWithWork) => state.demandWithWork = isUndefined(demandWithWork) ? false : demandWithWork,

        setUserInputCut:(state, value) => state.userInput.cut = value ? value : 0,
    },
}



// WEBPACK FOOTER //
// ./src/components/calculation/store.js